import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { parseAiSearchQuery } from "./ai-search.server";

export const aiParseSearch = createServerFn({ method: "POST" })
  .inputValidator((input) => {
    const labelItem = z.string().min(1).max(100).regex(/^[^\n\r\t<>{}]+$/);
    return z.object({
      query: z.string().min(1).max(500),
      specialties: z.array(labelItem).max(200),
      cities: z.array(labelItem).max(500),
      insurances: z.array(labelItem).max(200),
      lang: z.enum(["en", "es", "auto"]).optional(),
    }).parse(input);
  })
  .handler(async ({ data }) => {
    const result = await parseAiSearchQuery(data);
    return { result };
  });
